export const UrlParams = {
    conversationsMessageId: ':conversationMessageId',
    customViewId: ':customViewId',
    recordId: ':recordId',
    entityName: ':entityName',
    entityTab: ':entityTab',
    externalView: ':externalView',
    macroId: ':macroId',
    behaviorId: ':behaviorId',
    friendlyPartnerId: ':friendlyPartnerId',
    workflowId: ':workflowId',
    workflowVersionId: ':workflowVersionId',
};
/** Query-string keys, shared by the code that writes a link and the code that reads it. */
export const UrlQueryParams = {
    messageId: 'messageId',
};
export const PageRoots = {
    root: '/',
    friendlyPartnerId: `/${UrlParams.friendlyPartnerId}`,
    inbox: '/inbox',
    drafts: '/drafts',
    conversation: '/conversations',
    site: '/sites',
    client: '/clients',
    search: '/search',
    views: '/views',
    view: '/view',
    crm: '/crm',
    settings: '/settings',
    originalEmail: '/original-email',
    landingPagePreview: '/landing-page-preview',
    notFound: '/404',
};
export const UrlSegments = {
    crm: {
        organizations: 'organizations',
        projects: 'projects',
        users: 'users',
    },
    view: {
        all: 'all',
    },
    settings: {
        businessHours: 'business-hours',
        signalBusinessHours: 'signal-business-hours',
        channels: 'channels',
        channelsVoice: 'voice',
        companyInfo: 'company-info',
        dataImport: 'data-import',
        holidaySchedule: 'holiday-schedule',
        macros: 'macros',
        macrosCreateMacro: 'new',
        macrosDisabled: 'disabled',
        manageCustomAttributes: 'properties',
        manageLabels: 'labels',
        memberships: 'memberships',
        preferences: 'preferences',
        rulesEngine: 'rules',
        rulesEngineCreateRule: 'new',
        rulesEngineDisabled: 'disabled',
        signal: 'signal',
        workflows: 'workflows',
        billing: 'billing',
        users: 'users',
        usersDisabled: 'disabled',
        usersAssigneeGroups: 'assignee-groups',
        usersV2: 'v2-users',
        blockedContacts: 'blocked-contacts',
        stripeReports: 'stripe-reports',
        notifications: 'notifications',
        integrations: 'integrations',
        integrationsDeveloper: 'developer',
    },
};
